import React, { useState, useEffect } from "react"; // eslint-disable-line no-unused-vars
import { Grid2 as Grid, Button, Paper } from "@mui/material";
import {
  Donation,
  DefaultDonation,
  CodeDetails,
  Charity,
  Settings,
} from "../../../shared/types";
import { getCharity } from "../../../shared/utilities/actions";
import { calculateCurrentDonationAmount } from "../../../shared/utilities/tools";
import {
  DonationInstructions,
  DonationAmount,
  DonationMessage,
  DonationSummary,
} from "../components";
import {
  isPhoneValid,
  isNameValid,
  isStreetValid,
  isCityValid,
  isZipValid,
  isEmailValid,
  isAttributionValid,
  isDesignationValid,
  isStateValid,
  isDonationAmountValid,
  isValidDonation,
} from "../../../shared/utilities/validators";

export interface DonationInputsProps {
  busy: boolean;
  codeDetails: CodeDetails;
  settings: Settings;
  ein: string;
  donations: Donation[];
  handleSubmit: (donation: Donation) => void;
  handleRemove: (donation: Donation) => void;
}

export const DonationInputs = ({
  busy,
  codeDetails,
  settings,
  ein,
  donations,
  handleSubmit,
  handleRemove,
}: DonationInputsProps): React.JSX.Element | null => {
  const [donation, setDonation] = useState<Donation>({
    ...DefaultDonation,
    amount: settings.donationDefault,
  });
  const [editMode, setEditMode] = useState<boolean>(false);
  const [charity, setCharity] = useState<Charity | null>();

  useEffect(() => {
    fetchCharity(ein);
    fetchDonation(ein);
  }, []);

  const fetchCharity = async (ein: string) => {
    let charityResponse: Charity | null = await getCharity(ein);
    setCharity(charityResponse);
  };

  const fetchDonation = (ein: string) => {
    let existingDonation = donations.find((item) => {
      return item.ein == ein;
    });
    if (existingDonation) {
      setDonation(JSON.parse(JSON.stringify(existingDonation)));
    }
  };

  if (charity) {
    return (
      <Grid size={{ xs: 12 }} container spacing={2}>
        <Grid size={{ xs: 12, sm: 4 }}>
          <img
            src={charity.managed.displayBannerUrl}
            style={{ borderRadius: "24px", width: "100%" }}
          />
        </Grid>
        <DonationSummary
          busy={busy}
          codeDetails={codeDetails}
          settings={settings}
          donation={donation}
          charity={charity}
          editMode={editMode}
          handleEditMode={() => {
            setEditMode(true);
          }}
          handleRemove={() => {
            handleRemove(donation);
          }}
        />
        {editMode && (
          <Grid size={{ xs: 12 }}>
            <Paper sx={{ padding: "16px" }}>
              <Grid size={{ xs: 12 }} container spacing={2}>
                <DonationAmount
                  codeDetails={codeDetails}
                  settings={settings}
                  donation={donation}
                  currentDonationAmount={calculateCurrentDonationAmount(
                    donations,
                    charity.ein
                  )}
                  handleChange={(updatedDonation: Donation) => {
                    setDonation(updatedDonation);
                  }}
                />
                <DonationMessage
                  settings={settings}
                  donation={donation}
                  handleChange={(updatedDonation: Donation) => {
                    setDonation(updatedDonation);
                  }}
                />
                <DonationInstructions
                  codeDetails={codeDetails}
                  settings={settings}
                  donation={donation}
                  handleChange={(updatedDonation: Donation) => {
                    setDonation(updatedDonation);
                  }}
                />
                <Grid size={{ xs: 12 }} style={{ textAlign: "right" }}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setEditMode(false);
                      fetchDonation(ein);
                    }}
                    disabled={busy}
                    className="tb_cancel_button"
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="outlined"
                    disabled={!isValidDonation(donation, settings) || busy}
                    onClick={() => {
                      if (donation.amount >= settings.donationMinimum) {
                        handleSubmit(donation);
                        setEditMode(false);
                      }
                    }}
                    className="tb_action_button"
                  >
                    Update
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        )}
      </Grid>
    );
  } else {
    return null;
  }
};
